// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/hr/Hr.css
// module id = 2008
// module chunks = 0